import React from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useParams,
} from "react-router-dom";

import Home from "./compnents/home/Home";
import Profile from "./compnents/profile/Profile";
import NotFound from "./compnents/notFound/NotFound";
import Signup from "./compnents/SignupIn/Signup";
import Login from "./compnents/login/Login";
import NoAccess from "./compnents/noAccess/NoAccess";
import ProfileUpdate from "./compnents/profile/ProfileUpdate";
import AnonymousSharing from "./compnents/anonymous/AnonymousSharing";
import AnonymousPost from "./compnents/anonymous/AnonymousPost";
import AllAnonymousPost from "./compnents/anonymous/AllAnonymousPost";
import AboutUs from "./compnents/aboutUs/AboutUs";
import Createjournal from "./compnents/journal/Createjournal.jsx";
import Readjournal from "./compnents/journal/Readjournal.jsx";
import JournalDetail from "./compnents/journal/Readonejournal.jsx";
import MoodTrack from "./compnents/moodtrack/MoodTrack.jsx";
import Quiz from "./compnents/quiz/Quiz.jsx";
import AllGames from "./compnents/games/AllGames.jsx";
import UpdateJournal from "./compnents/journal/Updatejournal.jsx";
import Therapist from "./compnents/AITherapist/Therapist.jsx";
import BookCounsellor from "./compnents/bookCounsellor/BookCounsellor.jsx";
import CounsellorAppointmentsPage from "./compnents/CounsellorAppointmentsPage/CounsellorAppointments.jsx";
import AllApp from "./compnents/AllAppointments/AllAppointmentsPage.jsx";
import ChatPage from "./compnents/chatPage/ChatPage.jsx";
import { ChakraProvider } from "@chakra-ui/react";
import VideoCall from "./compnents/videoCall/VideoCall.jsx";
import Footer from "./compnents/Footer/Footer.jsx";
import BreathingGame from "./compnents/games/BreathingGame.jsx";
import NavbarHome from "./compnents/navbar/NavbarHome.jsx";
import MoodAnalyzer from "./compnents/moodAnalyser/MoodAnalyser.jsx";
import ZenMemory from "./compnents/games/ZenMemory.jsx";
import MeditationGame from "./compnents/games/MeditationGame.jsx";
import BubbleZen from "./compnents/games/BubbleZen.jsx";
const PrivateRoute = ({ children }) => {
  const { username: usernameFromUrl } = useParams(); // Extract username from URL
  const token = localStorage.getItem("token");
  const usernameFromStorage = localStorage.getItem("tokenUser");

  if (!token || usernameFromUrl !== usernameFromStorage) {
    localStorage.removeItem("token");
    localStorage.removeItem("tokenUser");
    return <Navigate to="/unauthorizedAccess" />;
  }

  return children;
};

function App() {
  return (
    <ChakraProvider resetCSS={false}>
      <BrowserRouter>
      <NavbarHome />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route
            path="/:username/profile"
            element={
              <PrivateRoute>
                <Profile />
              </PrivateRoute>
            }
          />
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/unauthorizedAccess" element={<NoAccess />} />
          <Route
            path="/:username/updateprofile"
            element={
              <PrivateRoute>
                <ProfileUpdate />
              </PrivateRoute>
            }
          />
          <Route
            path="/:username/anonymoussharing"
            element={
              <PrivateRoute>
                <AnonymousSharing />
              </PrivateRoute>
            }
          />
          <Route
            path="/:username/createanonymouspost"
            element={
              <PrivateRoute>
                <AnonymousPost />
              </PrivateRoute>
            }
          />
          <Route
            path="/:username/allanonymousposts"
            element={
              <PrivateRoute>
                <AllAnonymousPost />
              </PrivateRoute>
            }
          />
          <Route
            path="/:username/mood"
            element={
              <PrivateRoute>
                <MoodTrack />
              </PrivateRoute>
            }
          />
          <Route
            path="/:username/quiz"
            element={
              <PrivateRoute>
                <Quiz />
              </PrivateRoute>
            }
          />
          <Route
            path="/:username/therapist"
            element={
              <PrivateRoute>
                <Therapist />
              </PrivateRoute>
            }
          />
          <Route
            path="/:username/bookcounsellor"
            element={
              <PrivateRoute>
                <BookCounsellor />
              </PrivateRoute>
            }
          />
          <Route
            path="/:username/counsellorappointments"
            element={
              <PrivateRoute>
                <CounsellorAppointmentsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/:username/appointments"
            element={
              <PrivateRoute>
                <AllApp />
              </PrivateRoute>
            }
          />
          <Route path="/aboutus" element={<AboutUs />} />

          <Route path="/chat/:room" element={<ChatPage />} />
          <Route path="/video/:room" element={<VideoCall />} />

          <Route
            path="/:username/createjournal"
            element={
              <PrivateRoute>
                <Createjournal />
              </PrivateRoute>
            }
          />
          <Route
            path="/:username/readjournals"
            element={
              <PrivateRoute>
                <Readjournal />
              </PrivateRoute>
            }
          />
          <Route
            path="/:username/readjournals/:id"
            element={
              <PrivateRoute>
                <JournalDetail />
              </PrivateRoute>
            }
          />
          <Route
            path="/:username/journals/:id/edit"
            element={
              <PrivateRoute>
                <UpdateJournal />{" "}
              </PrivateRoute>
            }
          />

          <Route
            path="/games"
            element={
                <AllGames />
            }
          />

          <Route path="/games/breathinggame" element={
                <BreathingGame />
            }
          />

          <Route
            path="/games/zenmemory"
            element={
                <ZenMemory />
            }
          />
          <Route
            path="/games/meditation"
            element={
                <MeditationGame />
            }
          />
          <Route
            path="/games/bubblezen"
            element={
                <BubbleZen />
            }
          />
          <Route path="/analyseMood/:username" element={ 
            <PrivateRoute>
              <MoodAnalyzer />
            </PrivateRoute>
          }
        />

          <Route path="*" element={<NotFound />} />
        </Routes>
      <Footer />
      </BrowserRouter>
    </ChakraProvider>
  );
}

export default App;
